import { render, staticRenderFns } from "./LText.vue?vue&type=template&id=0d0feade&"
import script from "./LText.vue?vue&type=script&lang=js&"
export * from "./LText.vue?vue&type=script&lang=js&"
import style0 from "./LText.vue?vue&type=style&index=0&id=0d0feade&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports